import { Role } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { LayoutIcon } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { component_url } from "src/libs/utilities/links"
import { IFeedProps } from "src/modules/pe-basic-module/views/core/FeedComponent"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import { eventTypes } from "src/modules/pe-topos-module/data/mocks/eventTypes"
import EventTypeLabel from "src/modules/pe-topos-module/views/labels/EventTypeLabel"
import { Intent, Tag } from "@blueprintjs/core"
import { useEffect } from "react"
import Moment from "react-moment"
import { NavLink } from "react-router-dom" 

/* Protopia Ecosystem component */
export interface IFestivalButtonProps extends IFeedProps {
    item: ILand
}

const EventCard = (props: IFestivalButtonProps): JSX.Element => { 
  let colClass = " col-12 " 
  if( props.params?.col )
  {
      switch(parseInt( props.params?.col ))
      {
          case 2:
              colClass = " col-md-6 "
              break;
          case 3:
              colClass = " col-md-4 "
              break;
          case 4:
              colClass = " col-md-3 "
              break;
          case 1:
          default:                
              colClass = " col-12 "
              break;

      }
  }
    return <Card 
        icon={props.item.icon}
        thumbnail={props.item.defaultThumbnail}
        status={props.item.status}
        title={props.item.name}
        startDate={props.item.startDate}
        finishDate={props.item.finishDate}
        color={props.item.color}
        description={props.item.description}
        site={props.item}
        url={ `${component_url("FestivalView")}fest/${props.item.id?.toString()}` }
        colClass={colClass}
    /> 
}
export default EventCard

const Card = (props: any) : JSX.Element => {
  useEffect(() => {
    addCSSClass(
      `landCards-${props.site.id}`,  
      `.land-card-${props.site.id} {
        width: 100%;
        height: 380px;
        min-height: 125px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(${ props.site.defaultThumbnail });
        background-color: ${props.site.color}!important; 
      }`
    )
    return () => {
      removeCSSClass(`landCards-${props.site.id}`)
    }
  }, [])

  const start = parseInt(props.startDate) * 1000
  const finish = parseInt(props.finishDate) * 1000
  let progress = props.startDate && props.finishDate ? ( Date.now() - start ) / ( finish - start ) : 0
  progress = progress > 1 ? 1 : progress

  return <div className={`p-0 ${props.colClass}`}> 
    <NavLink to={props.url} >
      <div className={` card land-card-${props.site.id} pe-light text-center text-secondary border-0 card-top-img `} >
        <div className="position-absolute top left w-100 h-100 d-flex flex-column z-index-1 untouchble" >
          <EventTypeLabel 
            item={{...props.site, eventTypes: eventTypes().filter(et => props.site.event_types?.includes(et.title))}} 
            className="position-absolute top left m-1" 
            isShort
          />
          <div  
            className="card-image bg-transparent"
            style={{ 
              width: "100%", 
              height: 100,
              minHeight: 100, 
            }}
          >
          {
            props.icon &&
            <div className="card-image-icon bg-light">
                <LayoutIcon
                    height={33}
                    width={33}
                    style={{ height: 33, width: 33, margin: 7 }}
                    src={props.icon}
                />
            </div>
          }
          </div>
          {
            !!props.site.viewRoles?.length 
              ?
              <div className=" mt-1 position-relative">
                <div className="position-absolute-1 mx-auto w-100 flex-centered flex-wrap mt-4 px-1">
                  <div className="small mb-1 w-100 available-for-label-container">
                    <span className="label">
                      { __("Available only for") }:
                    </span>
                  </div>
                  {
                    props.site.viewRoles.map((wr: Role) => <Tag key={wr} className="px-3 py-0 mr-1 mb-1" round intent={Intent.DANGER}>{__(wr)}</Tag> )
                  }
                </div> 
              </div>
              :
              <div style={{height:35}} />
          }
          <div className="flex-grow-100"></div> 
          <div className="card-body d-flex flex-column align-items-center mt-auto p-0">  
            <div className="card-text px-3 pb-1 w-100 flex-centered" >
              {
                props.startDate && <Tag minimal round className="mr-3 px-3 text-dark bg-light-contrast"> 
                <Moment  locale="ru" format="D.MM.YYYY" >
                  { start }
                </Moment>
              </Tag>
              }
              {
                props.finishDate && <Tag minimal round className="px-3 text-dark bg-light-contrast">
                  <Moment  locale="ru" format="D.MM.YYYY" >
                    { finish }
                  </Moment>
                </Tag>
              }
            </div> 
            {/* <div className="card-text px-3 pb-2 text-force-contrast" dangerouslySetInnerHTML={{ __html: __(props.description) }}/> */}
            <h4 className="card-title py-0 px-3 m-0 mb-5">
              <span className="py-1 px-3" dangerouslySetInnerHTML={{ __html:__(props.title) }}/>
            </h4> 
          </div> 
        </div>
        <div className=" position-absolute w-100 bottom left z-index-2 p-0 m-0 ">
          { 
            (progress < 1 && progress > 0)  
              ? 
              <div className="text-right opacity_5 mr-2 mt-1 small">{ Math.floor(progress * 100)}%</div> 
              : 
              null
          }
          <div
            className={ progress >= 1 || progress === 0 ? "d-none" : "h_5 low-animate-progress-bar" } 
          >
            <div className="bp5-progress-meter" style={{ width:`${progress * 100}%`, backgroundColor: props.color }} /> 
          </div>
        </div> 
        {
          props.site.archived && 
            <div className="mine-corner-no-verified corner-card-project pe-pennant-dark">
                {__("in archive")}
            </div>
        } 
      </div>
    </NavLink>
  </div>
}